import { zonedTimeToUtc } from "date-fns-tz";

export const formatCurrency = (value: number): string => {
	if (value >= 1_000_000_000) {
		return `$${(value / 1_000_000_000).toFixed(2)}B`;
	}
	if (value >= 1_000_000) {
		return `$${(value / 1_000_000).toFixed(2)}M`;
	}
	if (value >= 1_000) {
		return `$${(value / 1_000).toFixed(2)}K`;
	}
	return `$${value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const formatCurrencyFull = (value: number): string => {
	return `$${value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

/**
 * End of the selected calendar day in `timeZone`, as a UTC Date.
 * Uses the date picker's local calendar day (getFullYear/getMonth/getDate) so the chosen
 * day does not shift when company timezone differs from the browser (formatInTimeZone on
 * the instant would map midnight Eastern to the previous day in Central, etc.).
 */
export const dueDateToEndOfDayInTimeZone = (dueDate: Date, timeZone: string): Date => {
	const y = dueDate.getFullYear();
	const m = String(dueDate.getMonth() + 1).padStart(2, "0");
	const d = String(dueDate.getDate()).padStart(2, "0");
	const dateKey = `${y}-${m}-${d}`;
	return zonedTimeToUtc(`${dateKey} 23:59:59.999`, timeZone);
};
